<div class="ig-close-button close-btn-place-bg" (click)="close()" role="button">
    BACK TO ALL PLACES
</div>

<div class="confirm-modal ig-modal place-details-modal">
    <ig-spinner *ngIf="isLoadingPlace"></ig-spinner>

    <div class="place-info-row flex">
        <div class="place-data-wrap panel">
            <div #image class="relative place-img-wrap">
                <div *ngIf="contentLoaded" class="flex full-height">
                    <div vision class="relative" [ngStyle]="{ 'flex': (!place._360VideoKey&&!place.youtubeLink)?2:1}">
                        <ig-image #imgComp *ngIf="place?.socialName!=='google'" [imageUrl]="place?.cover?.source"
                            [alt]="place?.title||place?.name"></ig-image>
                        <ig-image-viewer #imgViewer *ngIf="place?.socialName==='google'&&isGoogleInfoLoaded"
                            [images]="placePhotos" [alt]="place?.title||place?.name"
                            [showingCount]=placeImagesShownCount></ig-image-viewer>
                        <ig-social-share [item]="place" [appearance]="'white'" (onShareEmail)="addShareEmail()"
                            (onShareToFB)="addShareFB()" (onShareToTweet)="addShareTweet()">
                        </ig-social-share>
                    </div>
                    <iframe vision *ngIf="place._360VideoKey&&!place.youtubeLink" [src]="_360Url" frameborder="0"
                        allowfullscreen="1" width="100%" height="100%" style="max-width:100%;"></iframe>
                    <iframe vision *ngIf="place.youtubeLink" width="100%" height="100%" [src]="_youtubeUrl"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    <ig-place-map-section *ngIf="!place._360VideoKey&&!place.youtubeLink"
                        style="flex:1;margin-left: 16px" [hubName]="hubName" [mapZoom]="mapZoom"
                        [isAccommodation]="isAccommodation" [hideIconMapStyler]="hideIconMapStyler" [place]="place"
                        [featuresToggle]="featuresToggle" [googlePlaceAdditionalData]="googlePlaceAdditionalData"
                        (onGotoWebsite)="addGotoWebsiteCount()" (onGetDirection)="addGetDirectionCount()">
                    </ig-place-map-section>
                </div>

                <div *ngIf="place?.socialName==='google'&&!isGoogleInfoLoaded" class="google-img-loading">
                    <ig-spinner></ig-spinner>
                </div>
                <!--                <ig-social-share [item]="place" [appearance]="'white'"></ig-social-share>-->
            </div>
            <div des *ngIf="contentLoaded" class="panel m-t-1" style="max-height: 50%">
                <div class="flex place-map-wrap" #mapColumn>
                    <div group class="place-title">
                        <p>{{place?.title || place?.name}}</p>
                        <div *ngFor="let add of addressSegs">{{add}}</div>
                        <div *ngIf="place?.phone">{{place.phone}}</div>
                        <div *ngIf="googlePlaceAdditionalData?.formatted_phone_number&&!place?.phone">
                            {{googlePlaceAdditionalData.formatted_phone_number}}
                        </div>
                        <div *ngIf="place?.emails">{{place.emails}}</div>
                        <div *ngIf="place?.priceRange">{{place.priceRange}}</div>
                        <div *ngIf="googlePlaceAdditionalData?.price_level&&!place?.priceRange"><span
                                *ngFor="let x of priceLevel">$</span></div>

                        <div class="m-t-3 font-bold">Category</div>
                        <div>{{place?.category}}</div>
                        <!--                        <ig-powered-by [style]="'full-vertical'"></ig-powered-by>-->
                    </div>

                    <div group class="p-l-3 full-height">
                        <div *ngIf="!!place?.rating">
                            <p>Rating {{place?.rating}}</p>
                            <ig-stars [rating]="place?.rating"></ig-stars>
                        </div>

                        <div
                            *ngIf="!googlePlaceAdditionalData?.opening_hours&&googlePlaceAdditionalData?.user_ratings_total">
                            <strong>User Ratings Total: {{googlePlaceAdditionalData?.user_ratings_total}}</strong>
                        </div>

                        <div *ngIf="place.business_status?.includes('CLOSED'); else hours"
                            style="padding: 4px;color:white;background:rgb(233, 58, 87);text-align: center;">
                            {{place.business_status.replace('_', ' ')}}
                        </div>
                        <ng-template #hours>
                            <ig-visitor-place-opening-hours [googlePlaceAdditionalData]="googlePlaceAdditionalData"
                                [hours]="place?.hours" [hoursText]="place?.hoursText"></ig-visitor-place-opening-hours>
                        </ng-template>

                    </div>

                    <div group>
                        <div *ngIf="hasDescription&&contentLoaded&&!place._360VideoKey">
                            <p>About</p>                            
                            <div class="opening-hours" [innerHTML]="sanitizer.bypassSecurityTrustHtml(hasDescription || '(No Description)')"></div>
                        </div>
                        <ig-place-map-section *ngIf="contentLoaded&&(place._360VideoKey||place.youtubeLink)"
                            [hubName]="hubName" [mapZoom]="mapZoom" [isAccommodation]="isAccommodation"
                            [hideIconMapStyler]="hideIconMapStyler" [place]="place" [featuresToggle]="featuresToggle"
                            [googlePlaceAdditionalData]="googlePlaceAdditionalData"
                            (onGotoWebsite)="addGotoWebsiteCount()"
                            (onGetDirection)="addGetDirectionCount()"></ig-place-map-section>
                    </div>
                </div>

                <!--<div link>-->
                <!--<ig-button class="gray-btn" (trigger)="showPlaceLink()">Get Place Link</ig-button>-->
                <!--</div>-->


                <div *ngIf="hasDescription&&contentLoaded&&place._360VideoKey">
                    <p>About</p>                    
                    <div class="opening-hours" [innerHTML]="sanitizer.bypassSecurityTrustHtml(hasDescription)"></div>
                </div>

                <!--                <div style="position: absolute;font-size: 60px;top:45%;right:16px;color: lightgray;cursor: pointer"> > </div>-->
            </div>

            <!--            <span class="text-left">-->
            <!--                <ig-powered-by [style]="'full-vertical'"></ig-powered-by>-->
            <!--            </span>-->
        </div>
        <div style="flex:1;" class="flex post-wrap">
            <div *ngIf="place?.socialName==='google'&&!isGoogleInfoLoaded" class="google-img-loading">
                <ig-spinner></ig-spinner>
            </div>
            <div *ngIf="featuresToggle?.googleReviews&&contentLoaded&&(place?.socialName==='google'||place?.isManuallyCreated)"
                class="panel post-panel">
                <ig-google-place-reviews [reviews]="googleReviews" [placeId]="place?.id"
                    [columns]="(featuresToggle?.facebookPosts||featuresToggle?.nearbyPlacesRight)?1:2"
                    [googleLink]="googlePlaceAdditionalData?.url||googlePlaceAdditionalData?.hostLink"
                    (onGotoGoogleList)="addGoToGoogleReview()"></ig-google-place-reviews>
            </div>

            <div *ngIf="(place?.socialName==='google'&&isGoogleInfoLoaded&&featuresToggle?.facebookPosts)||place?.socialName==='facebook'"
                class="panel place-details-feed-wrap post-panel" [class.bg-color]="noPostBackground">
                <ng-container *ngIf="isFacebookLoggedIn">
                    <div class="fb-post-title">
                        <img [src]="facebookLogo" alt="facebook logo">
                        FACEBOOK POSTS
                    </div>
                    <div #fbposts class="facebook-posts">
                        <ng-container *ngIf="show2ColumnsFacebookFeeds">
                            <div *ngFor="let r of placeFeedRows" class="flex">
                                <ig-facebook-post *ngFor="let post of r" [post]="post"></ig-facebook-post>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!show2ColumnsFacebookFeeds">
                            <ig-facebook-post *ngFor="let post of placeFeeds" [post]="post"></ig-facebook-post>
                        </ng-container>

                        <div *ngIf="place?.socialName==='google'&&placeFeeds&&!placeFeeds.length&&isGooglePlaceMatchedWithFBPlace"
                            class="no-content">No posts available
                        </div>
                        <div *ngIf="place?.socialName==='facebook'&&placeFeeds&&!placeFeeds.length" class="no-content">
                            No posts available
                        </div>
                        <div *ngIf="place?.socialName==='google'&&isMatchCompleted&&!isGooglePlaceMatchedWithFBPlace"
                            class="no-content">🤔...we could not find a Facebook Business Page for this location. If
                            you are the business owner, please contact us.
                        </div>
                        <ig-button *ngIf="placeFeedPaging?.next" [isAsync]="true" size="md"
                            (trigger)="getNextFacebookPlaceFeed($event)">
                            Load More
                        </ig-button>
                    </div>
                    <ig-button *ngIf="isGooglePlaceMatchedWithFBPlace||place?.socialName==='facebook'" class="fb-btn"
                        size="md" (trigger)="viewFBPage()">View Facebook Page
                    </ig-button>
                </ng-container>
                <ng-container *ngIf="!isFacebookLoggedIn">
                    <div class="fb-login-wrap">
                        <div class="flex">
                            <ig-fb-login-btn style="margin: auto"
                                (onLoginStatusChanged)="getFacebookPlaceFeed($event)"></ig-fb-login-btn>
                        </div>
                        <div logtip class="m-t-1">
                            Login with Facebook to view the Facebook posts by this place!
                        </div>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="featuresToggle?.nearbyPlacesRight&&contentLoaded"
                class="panel place-details-feed-wrap post-panel">
                <ig-nearby-places [position]="'right'" [currentPlace]="place" [source]="placeSource"
                    (onGotoPlace)="gotoPlace($event)"></ig-nearby-places>
            </div>
        </div>
    </div>

    <div *ngIf="!featuresToggle.nearbyPlacesRight" class="panel m-t-1 nearby-panel">
        <ig-nearby-places [position]="'bottom'" [currentPlace]="place" [source]="placeSource"
            (onGotoPlace)="gotoPlace($event)"></ig-nearby-places>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/place.details.modal/place.details.modal.component.html